import { createFileRoute } from "@tanstack/react-router";
import { buildRouteHead } from "@/lib/seo/routeHead";
import ServicePage from "@/pages/ServicePage";

export const Route = createFileRoute("/en/services/regulatory-toxicology/")({
  head: () => buildRouteHead("/en/services/regulatory-toxicology"),
  component: ServicePage,
});
